import React from 'react'
import Alerts from '../../components/alerts/alerts'

const Alert = ({userContext}) => {
  return <div>
      <Alerts userContext={userContext}/>
  </div>;
};

export default Alert;